import { Component } from '@angular/core';
import { LegalComponent } from './legal.component';

@Component({
  selector: 'legal-container',
  imports: [LegalComponent],
  templateUrl: './legal.container.component.html',
  styleUrl: './legal.container.component.scss',
})
export class LegalContainerComponent {}
